import currency from 'currency.js';

export const prettyMoney = (value, precision = 2) => currency(value, { symbol: "", precision }).format()

export const uglyMoney = (value) => currency(value).toString()